import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  selectedRoundData: {},
  showRoundDrawer: false,
};

const minesRoundDrawerSlice = createSlice({
  name: 'minesRoundDrawer',
  initialState,
  reducers: {
    setShowRoundDrawer: (state, { payload }) => {
      state.showRoundDrawer = payload;
    },
    setSelectedRound: (state, { payload }) => {
      state.selectedRoundData = payload;
    },
  },
});

export const { reducer: minesRoundDrawerReducer } = minesRoundDrawerSlice;
export const { setShowRoundDrawer, setSelectedRound } = minesRoundDrawerSlice.actions;
